/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type FineKinneyPossibilityDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: FineKinneyPossibilityDefinitionDto.source;
    label?: string;
    value?: string;
}

export namespace FineKinneyPossibilityDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
